export var TransactionMethodEnum;
(function (TransactionMethodEnum) {
    TransactionMethodEnum["CARD"] = "CARD";
    TransactionMethodEnum["WALLET"] = "WALLET";
    TransactionMethodEnum["BANK_WIRE"] = "BANK_WIRE";
    TransactionMethodEnum["FIREBLOCKS"] = "FIREBLOCKS";
    TransactionMethodEnum["INTERNAL"] = "INTERNAL";
    TransactionMethodEnum["CASH"] = "CASH";
})(TransactionMethodEnum || (TransactionMethodEnum = {}));
//# sourceMappingURL=transaction-method.enum.js.map